module.exports = __webpack_public_path__ + "img/895.ec3c1764.png";